// Web shim for react-native-gesture-handler
import React from 'react';
import { 
  View, 
  ScrollView as RNScrollView, 
  TouchableOpacity as RNTouchableOpacity,
  FlatList as RNFlatList,
  RefreshControl as RNRefreshControl
} from 'react-native';

// 使用React Native Web的组件作为后备方案
export const GestureHandlerRootView = View;
export const PanGestureHandler = View;
export const TapGestureHandler = RNTouchableOpacity;
export const LongPressGestureHandler = View;
export const RotationGestureHandler = View;
export const FlingGestureHandler = View;
export const PinchGestureHandler = View;
export const ForceTouchGestureHandler = View;
export const NativeViewGestureHandler = View;

// Gesture Handler的ScrollView和其他列表组件使用React Native的组件
export const GestureDetector = View;
export const ScrollView = RNScrollView;
export const FlatList = RNFlatList;
export const RefreshControl = RNRefreshControl;

// 手势状态常量
export const State = {
  UNDETERMINED: 0,
  FAILED: 1,
  BEGAN: 2,
  CANCELLED: 3,
  ACTIVE: 4,
  END: 5,
};

// 方向常量
export const Directions = {
  RIGHT: 1,
  LEFT: 2,
  UP: 4,
  DOWN: 8,
};

// 手势创建函数（返回空的包装器）
export const Gesture = {
  Pan: () => ({ withRef: () => {} }),
  Tap: () => ({ withRef: () => {} }),
  LongPress: () => ({ withRef: () => {} }),
  Rotation: () => ({ withRef: () => {} }),
  Fling: () => ({ withRef: () => {} }),
  Pinch: () => ({ withRef: () => {} }),
  ForceTouch: () => ({ withRef: () => {} }),
  Native: () => ({ withRef: () => {} }),
  Simultaneous: (...gestures: any[]) => ({ withRef: () => {} }),
  Exclusive: (...gestures: any[]) => ({ withRef: () => {} }),
  Race: (...gestures: any[]) => ({ withRef: () => {} }),
};

// 动画钩子（空实现）
export const useSharedValue = (initialValue: any) => ({ value: initialValue });
export const useAnimatedStyle = (styleFunc: any) => styleFunc();
export const useAnimatedGestureHandler = (handlers: any) => () => {};
export const useAnimatedScrollHandler = (handlers: any) => () => {};

// 触摸事件（导出为与react-native-gesture-handler兼容的名称）
export const TouchableOpacity = RNTouchableOpacity;
export const TouchableHighlight = RNTouchableOpacity;
export const TouchableWithoutFeedback = RNTouchableOpacity;

// RectButton 和 BorderlessButton（使用TouchableOpacity作为后备）
export const RectButton = RNTouchableOpacity;
export const BorderlessButton = RNTouchableOpacity;
export const BaseButton = RNTouchableOpacity;

// Swipeable（空实现）
export class Swipeable extends React.Component<any> {
  close() {}
  openLeft() {}
  openRight() {}
  render() {
    return React.createElement(View, this.props);
  }
}

// Drawer Layout（空实现）
export class DrawerLayout extends React.Component<any> {
  openDrawer() {}
  closeDrawer() {}
  render() {
    return React.createElement(View, this.props);
  }
}

// RawButton（空实现）
export const RawButton = View;

// 手势上下文
export const GestureContext = React.createContext(null);

// 启用手势（空操作）
export const enableExperimentalWebImplementation = () => {};

// 默认导出
export default {
  GestureHandlerRootView,
  PanGestureHandler,
  TapGestureHandler,
  LongPressGestureHandler,
  RotationGestureHandler,
  FlingGestureHandler,
  PinchGestureHandler,
  ForceTouchGestureHandler,
  NativeViewGestureHandler,
  GestureDetector,
  ScrollView: RNScrollView,
  FlatList: RNFlatList,
  RefreshControl: RNRefreshControl,
  State,
  Directions,
  Gesture,
  useSharedValue,
  useAnimatedStyle,
  useAnimatedGestureHandler,
  useAnimatedScrollHandler,
  TouchableOpacity: RNTouchableOpacity,
  TouchableHighlight: RNTouchableOpacity,
  TouchableWithoutFeedback: RNTouchableOpacity,
  RectButton: RNTouchableOpacity,
  BorderlessButton: RNTouchableOpacity,
  BaseButton: RNTouchableOpacity,
  Swipeable,
  DrawerLayout,
  RawButton,
  enableExperimentalWebImplementation,
};

